import { Button } from "components/Button/Button";
import { KeyWord } from "components/KeyWord/KeyWord";
import { ModalForm } from "components/ModalForm/ModalForm";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { getDictionaryAvailable } from "pages/OfficeAutomation/FormBuilder/api";
import React, { useEffect, useState } from "react";
import { InputTypes } from "types/enum";
import { trans } from "utils/helpers";
import { InputAvailable } from "../../../InputAvailable";

interface ColumnEditModalProps {
  show: boolean;
  onHide: () => void;
  onSave: (data:any) => void;
  initialTitle: string;
  initialType: string;
  initialSystemKey: string;
  initialFormula: string;
  selectedColumn: any;
}

export const ColumnEditModal: React.FC<ColumnEditModalProps> = ({
  show,
  onHide,
  onSave,
  initialTitle,
  initialType,
  initialSystemKey,
  initialFormula,
  selectedColumn,
}) => {
  const [title, setTitle] = useState(initialTitle);
  const [SystemKey, setSystemKey] = useState(initialSystemKey);
  const [type, setType] = useState<any>(initialType);
  const [inputTypes, setInputTypes] = useState<any>({});
  const [keyWords, setKeyWords] = useState<any>(selectedColumn?.Keywords ? selectedColumn?.Keywords:  []);
  const [formula, setFormula] = useState<string>(simplifyFormula(initialFormula))
function transformFormula(formula, isCondition = false) {
   formula=simplifyFormula(formula)

  // 1. Trim spaces inside quoted strings
  formula = formula.replace(/(["'])(.*?)\1/g, (match, quote, content) => {
    return quote + content.trim() + quote;
  });

  // 2. Convert string booleans/numbers inside quotes
  formula = formula.replace(/(["'])(0|1|False|True)\1/g, (match, quote, value) => {
    const map = { "0": "false", "1": "true", "False": "false", "True": "true" };
    return `"${map[value]}"`;
  });

  // 3. Replace single = with == outside quotes
  formula = formula.replace(/(^|[^=])=([^=])/g, (match, before, after, offset) => {
    const upToHere = formula.slice(0, offset + before.length);
    const quoteCount = (upToHere.match(/["']/g) || []).length;
    const insideQuotes = quoteCount % 2 !== 0;
    return insideQuotes ? match : `${before}==${after}`;
  });

  // 4. Process all variables in the formula
  formula = formula.replace(/\b(?!\d)\w+\b/g, (match2, offset) => {
    const before = formula.slice(0, offset);
    const quoteCount = (before.match(/["']/g) || []).length;

    if (quoteCount % 2 !== 0) return match2;        // Inside quotes
    if (!isNaN(match2)) return match2;               // A number
    if (formula.includes(`newObj.current?.${match2}`)) return match2; // already transformed
    
    // Check if it's part of a Math function
    const after = formula.slice(offset);
    if (before.endsWith('Math.') || after.startsWith('.') || 
        ['Math', 'ceil', 'floor', 'round', 'max', 'min', 'abs', 'pow', 'sqrt'].includes(match2)) {
      return match2;
    }

    return isCondition
      ? `DynamicFormData.${match2}`
      : `newObj.current?.${match2}`;
  });

  return formula;
} 


function simplifyFormula(input) {
  function removeNumberWrappers(str) {
    let prev;
    do {
      prev = str;
      str = str.replace(/Number\s*\(((?:[^()]+|\([^()]*\))*)\)/g, (_, inner) => inner);
    } while (str !== prev);
    return str;
  }

  let output = removeNumberWrappers(input);

  output = output
    .replace(/newObj\.current/g, '')
    .replace(/\?/g, '')
    .replace(/\.value/g, '')
    // حذف نقطه‌های اضافی **مگر زمانی که قبلش Math باشد**
    .replace(/(?<!Math)\.([a-zA-Z0-9_]+)/g, '$1')
    // مرتب کردن فاصله‌ها
    .replace(/\s*\*\s*/g, ' * ')
    .replace(/\s*\/\s*/g, ' / ')
    .replace(/\s*\+\s*/g, ' + ')
    .replace(/\s*-\s*/g, ' - ')
    .replace(/\(\s*/g, '(')
    .replace(/\s*\)/g, ')')
    .trim();

  return output;
}
  const handleSubmit = (e) => {
    let data = {
      ...inputTypes[type],
      title,
      label: title,
      SystemKey: SystemKey,
      initialSystemKey:inputTypes[type]?.SystemKey,
      typeName: inputTypes[type]?.typeName,
      icon: inputTypes[type]?.icon,
      type: inputTypes[type]?.type,
      backendType: inputTypes[type]?.backendType,
      inputType: inputTypes[type]?.inputType,
      Keywords: keyWords,
      Formula: transformFormula(formula) 
    }
    onSave(data);
    onHide();
  };

  const getDictionaryAvailableAsync = async () => {
    let inputTypesObject = {};
    const inputTypesArray = InputAvailable.filter(item => item.canUseInGrid);
    inputTypesArray.forEach(item => {
      inputTypesObject[item.typeName] = item;
    });
     try {
    const respons = await getDictionaryAvailable();
    
    respons.Data.map((item) => {
          inputTypesObject[item.SystemKey	] = {
           typeName: item.SystemKey,
           KeyId: item.Id ,
           Title:item.Title,
           typeNameEn: item.TitleEN,
           SystemKey: item.SystemKey,
           type: InputTypes.DynamicDictionary,
           backendType: "string",
         } ;
        })   
    } catch (error) {

    }
    setInputTypes(inputTypesObject);
  };

  useEffect(() => {
    getDictionaryAvailableAsync()
  }, []);

  return (
    <ModalForm
      title={trans("editcolumn")}
      show={show}
      onHide={onHide}
    >
      <form id="ColumnEditModal" className="card ">
        <div className="card-body row">
         <div className="mb-3 col-3">
            <Textbox
              textboxType="text"
              textboxName="title"
              labelText={trans("title")}
              defaultValue={title}
              value={title}
              onChange={(e) =>{
                if(e.target?.value?.includes('-')){
                   setTitle('')
                }else{
                  setTitle(e.target.value)
                } }}
              required
            />
          </div>
                    <div className="mb-3 col-3">
            <SelectBox
              lable={"type"}
              selectType="select"
              name="type"
              value={type}
              options={Object.values(inputTypes).map((item:any)=>item.Title?item.Title:item.typeName)}
              val={Object.keys(inputTypes)}
              mode="create"
              onChange={(e) =>{setType(e.target.value)}}
              Change={(e)=>setType(e)}
            />
          </div>
          <div className="mb-3 col-3">
            <Textbox
              textboxType="text"
              textboxName="SystemKey"
              labelText={trans("SystemKey")}
              defaultValue={SystemKey}
              onChange={(e) =>{   
                if(e.target?.value?.includes('-')){
                  setSystemKey('')
                }else{
                  setSystemKey(e.target.value)
                }}}
              required
            />
          </div>



          { (inputTypes[type]?.typeName === 'number' || inputTypes[type]?.typeName === 'decimalNumber' )&& (
            <div className="col-3 ">
              <Textbox
                textboxType="text"
                fixedLanguage="en"
                textboxName="Formula"
                labelText="Formula"
                defaultValue={simplifyFormula(initialFormula)}
                value={formula ?simplifyFormula(formula) :simplifyFormula(initialFormula)}
                onChange={(e) => setFormula(e.target.value)}
              />
            </div>
          )}
          {(inputTypes[type]?.typeName == 'selectBox') && (
            <div className="col-3">
              <div className="w-100 h-100">
                <KeyWord
                  name="KeyWords" 
                  withSystemKey={true}
                  label="options" 
                  setKeyWords={setKeyWords} 
                  keyWords={keyWords} 
                  required={true} 
                />
              </div>
            </div>
          )}
        </div>
      </form>
      <div className="col-lg-12 mt-1 btns_form">
        <Button form="ColumnEditModal" btnType="submit" onClick={handleSubmit} value="confirm" />
        <Button btnType="cancel" value="cancel" onClick={() => onHide()} />
      </div>
    </ModalForm>
  );
}; 